import React, { useState } from 'react';
import { Check, Star, AlertTriangle, ArrowRight, XCircle, MapPin, Menu, X } from 'lucide-react';
import { PopupNotification } from '../components/PopupNotification';
export function SalesPage() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const checkoutUrl = 'Link de tu checkout'; // Placeholder as requested
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
      setIsMenuOpen(false);
    }
  };
  return <div className="min-h-screen bg-[#0f172a] font-sans text-gray-100 overflow-x-hidden selection:bg-yellow-500 selection:text-black" data-id="element-13">
      <PopupNotification data-id="element-14" />

      {/* NAVBAR */}
      <nav className="sticky top-0 z-50 bg-[#0f172a]/95 backdrop-blur-md border-b border-white/10 shadow-lg" data-id="element-15">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-16">
          <div className="flex justify-between items-center h-16" data-id="element-17">
            <div className="flex-shrink-0 flex items-center gap-2 cursor-pointer" onClick={() => window.scrollTo(0, 0)} data-id="element-18">
              <span className="text-2xl" data-id="element-19">📘</span>
              <span className="font-bold text-white text-lg md:text-xl tracking-tight" data-id="element-20">
                Salud y Adolescencia 360
              </span>
            </div>

            {/* Desktop Menu */}
            <div className="hidden md:flex items-center space-x-8" data-id="element-21">
              <button onClick={() => scrollToSection('bonos')} className="text-gray-300 hover:text-white hover:text-[#eab308] transition-colors font-medium" data-id="element-22">
                Bonos
              </button>
              <button onClick={() => scrollToSection('testimonios')} className="text-gray-300 hover:text-white hover:text-[#eab308] transition-colors font-medium" data-id="element-23">
                Testimonios
              </button>
              <button onClick={() => scrollToSection('compra')} className="bg-[#dc2626] hover:bg-[#b91c1c] text-white px-6 py-2 rounded-full font-bold shadow-lg hover:shadow-red-500/30 transition-all transform hover:-translate-y-0.5" data-id="element-24">
                COMPRAR
              </button>
            </div>

            {/* Mobile Menu Button */}
            <div className="md:hidden" data-id="element-25">
              <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-gray-300 hover:text-white p-2" data-id="element-26">
                {isMenuOpen ? <X size={24} data-id="element-27" /> : <Menu size={24} data-id="element-28" />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && <div className="md:hidden bg-[#1e293b] border-b border-white/10" data-id="element-29">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3" data-id="element-30">
              <button onClick={() => scrollToSection('bonos')} className="block w-full text-left px-3 py-2 text-gray-300 hover:text-white hover:bg-white/5 rounded-md font-medium" data-id="element-31">
                Bonos
              </button>
              <button onClick={() => scrollToSection('testimonios')} className="block w-full text-left px-3 py-2 text-gray-300 hover:text-white hover:bg-white/5 rounded-md font-medium" data-id="element-32">
                Testimonios
              </button>
              <button onClick={() => scrollToSection('compra')} className="block w-full text-center mt-4 bg-[#dc2626] text-white px-3 py-3 rounded-md font-bold" data-id="element-33">
                COMPRAR AHORA
              </button>
            </div>
          </div>}
      </nav>

      {/* 2. HERO SECTION */}
      <section className="relative pt-12 pb-24 md:pt-20 md:pb-32 px-4 overflow-hidden section-diagonal-bottom" data-id="element-34">
        {/* Background Image with blur */}
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: `url('https://cdn.magicpatterns.com/uploads/gMntWMtb1kaGcSuvSAenGy/Gemini_Generated_Image_ga4iy4ga4iy4ga4i.png')`,
        filter: 'blur(4px)',
        transform: 'scale(1.05)'
      }} data-id="element-35"></div>
        {/* Dark overlay for text readability */}
        <div className="absolute inset-0 bg-[#0a1628]/75" data-id="element-36"></div>

        <div className="max-w-5xl mx-auto text-center relative z-10" data-id="element-37">
          <div className="inline-flex items-center gap-2 bg-[#1e293b]/80 border border-[#eab308]/50 rounded-full px-4 py-1.5 mb-8 shadow-[0_0_15px_rgba(234,179,8,0.2)] backdrop-blur-sm" data-id="element-38">
            <Star size={14} className="text-[#eab308] fill-[#eab308]" data-id="element-39" />
            <span className="text-[#eab308] font-bold text-xs md:text-sm tracking-wide uppercase" data-id="element-40">
              EL SISTEMA #1 PARA DOCENTES DE SALUD
            </span>
            <Star size={14} className="text-[#eab308] fill-[#eab308]" data-id="element-41" />
          </div>

          <h1 className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black mb-10 leading-tight text-white drop-shadow-xl" data-id="element-42">
            SALUD Y ADOLESCENCIA 360:{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#eab308] to-[#facc15]" data-id="element-43">
              Herramientas Completas
            </span>
          </h1>

          {/* Mockup Image */}
          <div className="relative mx-auto max-w-2xl mb-8 cursor-pointer group" onClick={() => scrollToSection('compra')} data-id="element-44">
            <div className="absolute inset-0 bg-gradient-to-b from-[#16a34a]/30 to-[#1565c0]/30 blur-3xl opacity-60 group-hover:opacity-80 transition-opacity duration-500 rounded-full" data-id="element-45"></div>
            <img src="https://cdn.magicpatterns.com/uploads/5DMDqRg7UwQzQw52JscvSc/MOCKUP_SYA.png" alt="Salud y Adolescencia 360 Mockup" className="relative z-10 w-full drop-shadow-2xl transform group-hover:scale-[1.02] transition-transform duration-500" data-id="element-46" />
          </div>

          {/* New text block */}
          <div className="mb-10 max-w-3xl mx-auto" data-id="element-47">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-white mb-4 leading-tight drop-shadow-lg" data-id="element-48">
              ORGANIZA TU AÑO DE{' '}
              <span className="text-[#eab308]" data-id="element-49">Salud y adolescencia</span> SIN
              ESTRÉS
            </h2>
            <p className="text-base md:text-lg text-gray-200 leading-relaxed font-medium" data-id="element-50">
              Sistema completo de proyectos, experiencias y evaluaciones listas
              para usar.{' '}
              <span className="text-white font-bold" data-id="element-51">
                Todo tu año resuelto en un clic.
              </span>
            </p>
          </div>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 mb-8" data-id="element-52">
            <button onClick={() => scrollToSection('compra')} className="w-full md:w-auto bg-[#16a34a] hover:bg-[#15803d] text-white text-lg md:text-xl font-bold py-4 px-8 rounded-full shadow-[0_0_20px_rgba(22,163,74,0.4)] hover:shadow-[0_0_30px_rgba(22,163,74,0.6)] active:scale-95 transition-all flex items-center justify-center gap-2 border border-white/10" data-id="element-53">
              👉 QUIERO ACCEDER AHORA
            </button>
            <button onClick={() => scrollToSection('bonos')} className="w-full md:w-auto bg-transparent hover:bg-white/5 text-white border-2 border-white/20 hover:border-white/40 text-lg md:text-xl font-bold py-3.5 px-8 rounded-full transition-all flex items-center justify-center gap-2" data-id="element-54">
              Ver Bonos <ArrowRight size={20} data-id="element-55" />
            </button>
          </div>

          <div className="flex flex-wrap justify-center gap-4 text-sm text-gray-300 font-medium" data-id="element-56">
            <span className="flex items-center gap-1" data-id="element-57">
              <Check size={14} className="text-[#16a34a]" data-id="element-58" /> Acceso inmediato
            </span>
            <span className="hidden md:inline" data-id="element-59">·</span>
            <span className="flex items-center gap-1" data-id="element-60">
              <Check size={14} className="text-[#16a34a]" data-id="element-61" /> Descarga digital
            </span>
            <span className="hidden md:inline" data-id="element-62">·</span>
            <span className="flex items-center gap-1" data-id="element-63">
              <Check size={14} className="text-[#16a34a]" data-id="element-64" /> Garantía incluida
            </span>
          </div>
        </div>
      </section>

      {/* 2.5 QUÉ INCLUYE SECTION */}
      <section className="py-20 px-4 bg-[#f0f9ff] relative z-30" data-id="element-65">
        <div className="max-w-5xl mx-auto" data-id="element-66">
          {/* Section header */}
          <div className="text-center mb-12" data-id="element-67">
            <span className="inline-block bg-[#16a34a]/15 text-[#15803d] border border-[#16a34a]/30 rounded-full px-4 py-1 text-xs font-bold uppercase tracking-widest mb-4" data-id="element-68">
              Nivel Secundaria
            </span>
            <h3 className="text-3xl md:text-4xl font-black text-gray-900 mb-4" data-id="element-69">
              ¿Qué incluye el{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#15803d] to-[#16a34a]" data-id="element-70">
                Mega Pack?
              </span>
            </h3>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-71">
              Dentro de{' '}
              <span className="text-gray-900 font-bold" data-id="element-72">
                SALUD Y ADOLESCENCIA 360
              </span>{' '}
              encontrás todo lo que necesitás para dar clases con confianza
              durante todo el año.
            </p>
          </div>

          {/* Featured card */}
          <div className="bg-white rounded-3xl overflow-hidden border border-gray-200 shadow-xl max-w-4xl mx-auto" data-id="element-73">
            {/* Card hero image */}
            <div className="relative h-56 md:h-72 overflow-hidden" data-id="element-74">
              <img src="https://cdn.magicpatterns.com/uploads/gMntWMtb1kaGcSuvSAenGy/Gemini_Generated_Image_ga4iy4ga4iy4ga4i.png" alt="Nivel Secundaria" className="w-full h-full object-cover object-top" data-id="element-75" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" data-id="element-76"></div>
              <div className="absolute top-4 right-4 bg-[#16a34a] text-white text-xs font-black px-3 py-1.5 rounded-full shadow-lg uppercase tracking-wide" data-id="element-77">
                ✦ NIVEL SECUNDARIA
              </div>
              <div className="absolute bottom-5 left-6 flex items-center gap-3" data-id="element-78">
                <div className="w-9 h-9 bg-[#eab308] rounded-lg flex items-center justify-center shadow-lg shrink-0" data-id="element-79">
                  <span className="text-lg" data-id="element-80">📘</span>
                </div>
                <h4 className="text-2xl md:text-3xl font-black text-white drop-shadow-lg" data-id="element-81">
                  Salud y Adolescencia 360
                </h4>
              </div>
            </div>

            {/* Card body */}
            <div className="p-8 md:p-10" data-id="element-82">
              <p className="text-gray-600 text-base md:text-lg mb-8 leading-relaxed" data-id="element-83">
                Material completo y estructurado para docentes de secundaria.
                Todo lo que necesitás para dar clases de Salud y Adolescencia
                con claridad, sin improvisar y sin perder horas planificando.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-84">
                {['Planificación anual estructurada', 'Clases listas para aplicar', 'Actividades pensadas para adolescentes', 'Secuencia pedagógica clara', 'Recursos listos para usar', 'Material organizado paso a paso'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-85">
                    <div className="w-6 h-6 rounded-full border-2 border-[#16a34a] flex items-center justify-center shrink-0 bg-[#16a34a]/10" data-id="element-86">
                      <Check size={13} className="text-[#16a34a]" strokeWidth={3} data-id="element-87" />
                    </div>
                    <span className="text-gray-700 font-medium text-sm md:text-base" data-id="element-88">
                      {item}
                    </span>
                  </div>)}
              </div>

              <div className="mt-10 pt-8 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-89">
                <p className="text-gray-400 text-sm" data-id="element-90">
                  Todo incluido · Acceso inmediato · Descarga digital
                </p>
                <button onClick={() => scrollToSection('compra')} className="bg-[#16a34a] hover:bg-[#15803d] text-white font-bold py-3 px-8 rounded-full shadow-[0_0_15px_rgba(22,163,74,0.3)] hover:shadow-[0_0_25px_rgba(22,163,74,0.5)] transition-all flex items-center gap-2 whitespace-nowrap" data-id="element-91">
                  Quiero esto <ArrowRight size={18} data-id="element-92" />
                </button>
              </div>
            </div>
          </div>

          {/* FEATURES STRIP */}
          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto" data-id="element-93">
            {[{
            icon: '⏱️',
            color: 'from-[#1d4ed8] to-[#2563eb]',
            title: 'Ahorro de Tiempo',
            desc: 'No pierdas horas planificando. Tenés todo listo para aplicar directamente en el aula.'
          }, {
            icon: '✏️',
            color: 'from-[#d97706] to-[#f59e0b]',
            title: '100% Editable',
            desc: 'Archivos en Word y PDF para que puedas adaptarlos a tu propio estilo y grupo.'
          }, {
            icon: '📐',
            color: 'from-[#dc2626] to-[#ef4444]',
            title: 'Diseño Curricular',
            desc: 'Contenidos alineados a los núcleos de aprendizaje prioritarios y al diseño curricular.'
          }, {
            icon: '🎯',
            color: 'from-[#7c3aed] to-[#8b5cf6]',
            title: 'Versatilidad Total',
            desc: 'Ideal para cualquier modalidad de secundaria, pública o privada, urbana o rural.'
          }].map((f, i) => <div key={i} className="flex flex-col items-center text-center gap-3" data-id="element-94">
                <div className={`w-14 h-14 rounded-2xl bg-gradient-to-br ${f.color} flex items-center justify-center text-2xl shadow-lg`} data-id="element-95">
                  {f.icon}
                </div>
                <h5 className="font-bold text-gray-900 text-sm md:text-base" data-id="element-96">
                  {f.title}
                </h5>
                <p className="text-gray-500 text-xs md:text-sm leading-relaxed" data-id="element-97">
                  {f.desc}
                </p>
              </div>)}
          </div>
        </div>
      </section>

      {/* 3. BONUSES SECTION */}
      <section id="bonos" className="py-20 px-4 bg-[#f8fafc] section-diagonal-top section-diagonal-bottom relative z-20" data-id="element-98">
        <div className="max-w-4xl mx-auto" data-id="element-99">
          <div className="bg-gradient-to-r from-[#dc2626]/90 to-[#b91c1c]/90 backdrop-blur-sm text-white text-center py-3 px-6 font-bold rounded-full mx-auto max-w-3xl animate-pulse shadow-lg mb-10 border border-red-400/30" data-id="element-100">
            🎁 BONOS ESPECIALES — GRATIS POR EL DÍA DE HOY
          </div>

          <h3 className="text-3xl md:text-4xl font-black text-center mb-12 text-gray-900" data-id="element-101">
            Con tu compra hoy recibís estos{' '}
            <span className="text-[#dc2626]" data-id="element-102">3 bonos sin costo adicional:</span>
          </h3>

          <div className="flex flex-col gap-5 mb-12" data-id="element-103">
            {/* Bonus 1 */}
            <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-md hover:shadow-lg hover:border-[#eab308]/50 transition-all duration-300 group flex flex-row" data-id="element-104">
              <div className="bg-gray-50 p-4 flex justify-center items-center w-32 md:w-44 shrink-0 relative overflow-hidden" data-id="element-105">
                <img src="https://cdn.magicpatterns.com/uploads/9ZA13v3N7yEemJJAn45BJs/BONO_1_SYA.png" alt="Bono 1" className="w-full object-contain transform group-hover:scale-105 transition-transform duration-500 drop-shadow-lg" data-id="element-106" />
              </div>
              <div className="p-5 flex flex-col justify-center" data-id="element-107">
                <span className="inline-block bg-[#eab308]/15 text-[#92400e] border border-[#eab308]/40 text-xs font-bold px-3 py-1 rounded-full mb-2 w-fit" data-id="element-108">
                  BONO 1 — GRATIS HOY
                </span>
                <h4 className="text-lg font-bold text-gray-900 mb-1" data-id="element-109">
                  Plan B Docente
                </h4>
                <p className="text-sm text-gray-500 leading-relaxed" data-id="element-110">
                  40 Actividades Salvavidas para Salud y Adolescencia.
                  Rompe-hielos dinámicos y consignas rápidas para cuando la
                  clase no arranca.
                </p>
              </div>
            </div>

            {/* Bonus 2 */}
            <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-md hover:shadow-lg hover:border-[#eab308]/50 transition-all duration-300 group flex flex-row" data-id="element-111">
              <div className="bg-gray-50 p-4 flex justify-center items-center w-32 md:w-44 shrink-0 relative overflow-hidden" data-id="element-112">
                <img src="https://cdn.magicpatterns.com/uploads/rDV74eL5pfp8PLYpP1vubN/BONO_2_SYA.png" alt="Bono 2" className="w-full object-contain transform group-hover:scale-105 transition-transform duration-500 drop-shadow-lg" data-id="element-113" />
              </div>
              <div className="p-5 flex flex-col justify-center" data-id="element-114">
                <span className="inline-block bg-[#eab308]/15 text-[#92400e] border border-[#eab308]/40 text-xs font-bold px-3 py-1 rounded-full mb-2 w-fit" data-id="element-115">
                  BONO 2 — GRATIS HOY
                </span>
                <h4 className="text-lg font-bold text-gray-900 mb-1" data-id="element-116">
                  Pack Evaluar sin Estrés
                </h4>
                <p className="text-sm text-gray-500 leading-relaxed" data-id="element-117">
                  Evaluaciones trimestrales, trabajos prácticos y rúbricas de
                  corrección listas para usar.
                </p>
              </div>
            </div>

            {/* Bonus 3 */}
            <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-md hover:shadow-lg hover:border-[#eab308]/50 transition-all duration-300 group flex flex-row" data-id="element-118">
              <div className="bg-gray-50 p-4 flex justify-center items-center w-32 md:w-44 shrink-0 relative overflow-hidden" data-id="element-119">
                <img src="https://cdn.magicpatterns.com/uploads/chcQYJNJzekqcimPuGZ53p/BONO_3_SYA.png" alt="Bono 3" className="w-full object-contain transform group-hover:scale-105 transition-transform duration-500 drop-shadow-lg" data-id="element-120" />
              </div>
              <div className="p-5 flex flex-col justify-center" data-id="element-121">
                <span className="inline-block bg-[#eab308]/15 text-[#92400e] border border-[#eab308]/40 text-xs font-bold px-3 py-1 rounded-full mb-2 w-fit" data-id="element-122">
                  BONO 3 — GRATIS HOY
                </span>
                <h4 className="text-lg font-bold text-gray-900 mb-1" data-id="element-123">
                  Conversaciones que Sí Funcionan
                </h4>
                <p className="text-sm text-gray-500 leading-relaxed" data-id="element-124">
                  Guía de conversaciones diseñadas para abordar temas sensibles
                  con adolescentes reales.
                </p>
              </div>
            </div>
          </div>

          <p className="text-center text-xl font-medium text-gray-700" data-id="element-125">
            Valor total de los bonos:{' '}
            <span className="line-through text-gray-400 decoration-red-400/70 decoration-2" data-id="element-126">
              $29.970
            </span>{' '}
            — <span className="text-[#16a34a] font-bold" data-id="element-127">Hoy son GRATIS</span>
          </p>
        </div>
      </section>

      {/* 4. PURCHASE SECTION */}
      <section id="compra" className="py-24 px-4 bg-[#0a1628] relative section-diagonal-top z-10" data-id="element-128">
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-129">
          <h3 className="text-4xl md:text-5xl font-black text-white mb-10 drop-shadow-lg" data-id="element-130">
            🚀 Es tu turno
          </h3>

          {/* Main purchase card */}
          <div className="rounded-3xl overflow-hidden shadow-2xl border-2 border-[#ca8a04]/60 text-left" data-id="element-131">
            {/* Gold urgency banner */}
            <div className="bg-gradient-to-r from-[#ca8a04] via-[#eab308] to-[#ca8a04] text-white text-center py-3 px-4 font-bold text-sm md:text-base" data-id="element-132">
              ⚡ 🎁{' '}
              <span className="font-black" data-id="element-133">
                Incluye todos los bonos GRATIS por tiempo limitado
              </span>
            </div>

            {/* White card body */}
            <div className="bg-white" data-id="element-134">
              {/* Full-width image hero — background only, no floating text */}
              <div className="relative w-full h-56 md:h-72 overflow-hidden" data-id="element-135">
                <img src="https://cdn.magicpatterns.com/uploads/gMntWMtb1kaGcSuvSAenGy/Gemini_Generated_Image_ga4iy4ga4iy4ga4i.png" alt="" className="absolute inset-0 w-full h-full object-cover object-center" data-id="element-136" />
                <div className="absolute inset-0 bg-[#0a1628]/55" data-id="element-137"></div>
              </div>

              {/* Price + CTA area */}
              <div className="p-6 md:p-10" data-id="element-138">
                <div className="flex flex-col md:flex-row gap-8 md:gap-12" data-id="element-139">
                  {/* LEFT: checklist */}
                  <div className="flex-1 min-w-0" data-id="element-140">
                    <ul className="space-y-3" data-id="element-141">
                      {['Planificación anual estructurada', 'Clases listas para aplicar', 'Actividades pensadas para adolescentes', 'Secuencia pedagógica clara', 'Recursos listos para usar', '+ 3 Bonos exclusivos GRATIS'].map((item, i) => <li key={i} className="flex items-center gap-3" data-id="element-142">
                          <div className="w-6 h-6 rounded-full border-2 border-[#16a34a] flex items-center justify-center shrink-0 bg-[#16a34a]/10" data-id="element-143">
                            <Check size={13} className="text-[#16a34a]" strokeWidth={3} data-id="element-144" />
                          </div>
                          <span className="text-gray-700 font-medium text-sm md:text-base" data-id="element-145">
                            {item}
                          </span>
                        </li>)}
                    </ul>
                  </div>

                  {/* RIGHT: pricing + CTA */}
                  <div className="flex-1 min-w-0 flex flex-col justify-center" data-id="element-146">
                    <div className="mb-6 text-center md:text-left" data-id="element-147">
                      <p className="text-gray-400 text-base md:text-lg line-through mb-1" data-id="element-148">
                        Precio Normal: $49.990
                      </p>
                      <p className="text-5xl md:text-7xl font-black text-gray-900 tracking-tight leading-none mb-3" data-id="element-149">
                        $19.990
                      </p>
                      <span className="inline-block bg-[#16a34a] text-white text-sm font-black px-4 py-1.5 rounded-full mb-4 shadow-sm" data-id="element-150">
                        ¡AHORRÁS $30.000 HOY!
                      </span>
                      <p className="text-gray-500 text-sm" data-id="element-151">
                        Pago único · Acceso inmediato · Sin suscripciones
                      </p>
                    </div>

                    <a href="https://checkout.digitalmarket360.online/cart/42120499298359:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-[#ca8a04] via-[#eab308] to-[#ca8a04] hover:from-[#b45309] hover:via-[#d97706] hover:to-[#b45309] text-white text-lg md:text-xl font-black py-5 px-4 rounded-xl shadow-[0_4px_15px_rgba(202,138,4,0.4)] hover:shadow-[0_4px_25px_rgba(202,138,4,0.6)] active:scale-[0.98] transition-all text-center mb-3 tracking-wide" data-id="element-152">
                      ⚡ DESCARGAR EL PACK AHORA
                    </a>

                    <p className="text-center text-gray-500 text-sm mb-6" data-id="element-153">
                      👆 Hacé clic y empezá a organizar tu año
                    </p>

                    <div className="flex items-center justify-center gap-4 text-xs text-gray-400 flex-wrap" data-id="element-154">
                      <span className="flex items-center gap-1" data-id="element-155">
                        🔒 Pago Seguro
                      </span>
                      <span className="flex items-center gap-1" data-id="element-156">
                        💳 Todos los medios
                      </span>
                      <span className="flex items-center gap-1" data-id="element-157">
                        ⬇️ Descarga inmediata
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Guarantee bar */}
            <div className="bg-[#f0fdf4] border-t border-[#bbf7d0] px-6 md:px-10 py-5 flex items-start md:items-center gap-4" data-id="element-158">
              <div className="w-10 h-10 rounded-full bg-[#16a34a]/15 border-2 border-[#16a34a]/30 flex items-center justify-center shrink-0 text-[#16a34a] text-xl" data-id="element-159">
                🛡️
              </div>
              <div data-id="element-160">
                <p className="font-black text-[#15803d] text-sm md:text-base uppercase tracking-wide" data-id="element-161">
                  GARANTÍA DE SATISFACCIÓN TOTAL — 7 DÍAS
                </p>
                <p className="text-gray-500 text-xs md:text-sm mt-0.5" data-id="element-162">
                  Si no cumple tus expectativas, te devolvemos el 100% de tu
                  dinero. Sin preguntas, sin complicaciones.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 4B. PURCHASE SECTION — MEGAPACK PRO */}
      <section id="compra-pro" className="pt-0 pb-24 px-4 bg-[#0f172a] relative z-10" data-id="element-163">
        <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-164">
          <h3 className="text-4xl md:text-5xl font-black text-white mb-10 drop-shadow-lg" data-id="element-165">
            🚀 SALUD Y ADOLESCENCIA PRO
          </h3>

          {/* Pro purchase card */}
          <div className="rounded-3xl overflow-hidden shadow-2xl border-2 border-[#1565c0]/60 text-left" data-id="element-166">
            {/* Blue urgency banner */}
            <div className="bg-gradient-to-r from-[#1565c0] via-[#1d4ed8] to-[#1565c0] text-white text-center py-3 px-4 font-bold text-sm md:text-base" data-id="element-167">
              ⚡ 🎁{' '}
              <span className="font-black" data-id="element-168">
                Incluye todos los bonos GRATIS por tiempo limitado
              </span>
            </div>

            {/* White card body */}
            <div className="bg-white" data-id="element-169">
              {/* Full-width image hero */}
              <div className="relative w-full h-64 md:h-80 overflow-hidden" data-id="element-170">
                <img src="https://cdn.magicpatterns.com/uploads/vmygngo2eVMG1o7eQXJjtW/Upsell_SYA.png" alt="Salud y Adolescencia PRO" className="absolute inset-0 w-full h-full object-cover object-top" data-id="element-171" />
                <div className="absolute inset-0 bg-[#0f172a]/30" data-id="element-172"></div>
              </div>

              {/* Price + CTA area */}
              <div className="p-6 md:p-8" data-id="element-173">
                <div className="flex flex-col md:flex-row gap-6 md:gap-10" data-id="element-174">
                  {/* LEFT: product contents */}
                  <div className="flex-1 min-w-0" data-id="element-175">
                    <h4 className="text-base font-black text-gray-900 mb-3" data-id="element-176">
                      Salud y Adolescencia PRO:{' '}
                      <span className="text-[#1565c0]" data-id="element-177">
                        Kits de implementación en el aula
                      </span>
                    </h4>

                    {/* Included items */}
                    <div className="space-y-1.5 mb-4" data-id="element-178">
                      {['✅ Salud y Adolescencia 360 completo', '🎁 Los 3 bonos GRATIS incluidos'].map((item, i) => <p key={i} className="text-gray-700 font-semibold text-sm" data-id="element-179">
                          {item}
                        </p>)}
                    </div>

                    {/* Modules */}
                    <p className="text-xs font-black text-gray-500 uppercase tracking-widest mb-2" data-id="element-180">
                      🧩 Módulos PRO exclusivos
                    </p>
                    <div className="space-y-1.5" data-id="element-181">
                      {['🔥 Dinámicas de Participación para Adolescentes', '🔥 Manejo de Aula en Temas Sensibles', '🔥 Adaptaciones Rápidas por Tipo de Curso', '🔥 Pack Editable PRO'].map((item, i) => <div key={i} className="flex items-center gap-2" data-id="element-182">
                          <span className="text-gray-700 text-sm" data-id="element-183">{item}</span>
                        </div>)}
                    </div>
                  </div>

                  {/* RIGHT: pricing + CTA */}
                  <div className="flex-1 min-w-0 flex flex-col justify-center" data-id="element-184">
                    <div className="mb-5 text-center md:text-left" data-id="element-185">
                      <p className="text-gray-400 text-base line-through mb-1" data-id="element-186">
                        Precio Normal: $69.990
                      </p>
                      <p className="text-5xl md:text-6xl font-black text-gray-900 tracking-tight leading-none mb-3" data-id="element-187">
                        $27.990
                      </p>
                      <span className="inline-block bg-[#1565c0] text-white text-sm font-black px-4 py-1.5 rounded-full mb-3 shadow-sm" data-id="element-188">
                        ¡AHORRÁS $42.000 HOY!
                      </span>
                      <p className="text-gray-500 text-sm" data-id="element-189">
                        Pago único · Acceso inmediato · Sin suscripciones
                      </p>
                    </div>

                    <a href="https://checkout.digitalmarket360.online/cart/42120502771767:1" target="_blank" rel="noopener noreferrer" className="block w-full bg-gradient-to-r from-[#1565c0] via-[#1d4ed8] to-[#1565c0] hover:from-[#1e40af] hover:via-[#1d4ed8] hover:to-[#1e40af] text-white text-lg font-black py-4 px-4 rounded-xl shadow-[0_4px_15px_rgba(21,101,192,0.4)] hover:shadow-[0_4px_25px_rgba(21,101,192,0.6)] active:scale-[0.98] transition-all text-center mb-3 tracking-wide" data-id="element-190">
                      ⚡ QUIERO EL PACK PRO AHORA
                    </a>

                    <p className="text-center text-gray-500 text-sm mb-4" data-id="element-191">
                      👆 Hacé clic y empezá a organizar tu año
                    </p>

                    <div className="flex items-center justify-center gap-3 text-xs text-gray-400 flex-wrap" data-id="element-192">
                      <span data-id="element-193">🔒 Pago Seguro</span>
                      <span data-id="element-194">💳 Todos los medios</span>
                      <span data-id="element-195">⬇️ Descarga inmediata</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Guarantee bar */}
            <div className="bg-[#eff6ff] border-t border-[#bfdbfe] px-6 md:px-8 py-4 flex items-start md:items-center gap-4" data-id="element-196">
              <div className="w-9 h-9 rounded-full bg-[#1565c0]/15 border-2 border-[#1565c0]/30 flex items-center justify-center shrink-0 text-[#1565c0] text-lg" data-id="element-197">
                🛡️
              </div>
              <div data-id="element-198">
                <p className="font-black text-[#1565c0] text-sm uppercase tracking-wide" data-id="element-199">
                  GARANTÍA DE SATISFACCIÓN TOTAL — 7 DÍAS
                </p>
                <p className="text-gray-500 text-xs mt-0.5" data-id="element-200">
                  Si no cumple tus expectativas, te devolvemos el 100% de tu
                  dinero. Sin preguntas, sin complicaciones.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 5. TESTIMONIALS SECTION */}
      <section id="testimonios" className="py-20 px-4 bg-[#0d1f3c] section-diagonal-top relative z-0" data-id="element-201">
        <div className="max-w-6xl mx-auto" data-id="element-202">
          <h3 className="text-3xl md:text-4xl font-black text-center text-white mb-12" data-id="element-203">
            💬 Lo que dicen los docentes que{' '}
            <span className="text-[#eab308] underline decoration-4 decoration-[#eab308]/30" data-id="element-204">
              ya lo usan
            </span>
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-205">
            {[{
            name: 'Valeria M.',
            info: '38 años · Córdoba',
            text: 'Desde que tengo el sistema 360, entro al aula sabiendo exactamente qué hacer. Mis alumnos participan mucho más y llego los lunes sin ese nudo en el estómago.'
          }, {
            name: 'Romina G.',
            info: '44 años · Buenos Aires',
            text: 'Cuando empecé a usar este material me di cuenta de que el problema era el material anterior. Mis alumnos de 3° año ahora piden más clases de Salud. ¡Algo que nunca había pasado!'
          }, {
            name: 'Sebastián T.',
            info: '36 años · Rosario',
            text: 'El sistema 360 me dio la estructura y el lenguaje justo para abordar todo sin incomodidad. La planificación anual me ahorró horas y horas de trabajo.'
          }, {
            name: 'Marcela F.',
            info: '47 años · Mendoza',
            text: 'Este es el mejor material que tuve en mis manos para esta materia. Está pensado para el aula real. Mis colegas me preguntan qué cambié porque notan la diferencia.'
          }, {
            name: 'Laura P.',
            info: '33 años · La Plata',
            text: 'Dejé de planificar los domingos a la noche. Las clases fluyen solas y los chicos están enganchados. Si estás dudando, no lo pienses más. Vale cada peso.'
          }].map((t, i) => <div key={i} className="bg-[#0f172a] p-6 rounded-2xl shadow-lg border border-white/5 hover:border-[#0ea5e9]/30 transition-all duration-300 flex flex-col relative group" data-id="element-206">
                <div className="flex items-center gap-1 text-[#eab308] mb-4" data-id="element-207">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} size={14} fill="currentColor" data-id="element-208" />)}
                </div>
                <p className="text-gray-300 mb-5 flex-grow italic leading-relaxed text-sm" data-id="element-209">
                  "{t.text}"
                </p>
                <div className="flex items-center gap-3 mt-auto pt-4 border-t border-white/10" data-id="element-210">
                  <div className="w-10 h-10 bg-gradient-to-br from-[#1565c0] to-[#0a1628] rounded-full flex items-center justify-center text-white font-bold text-base shadow-inner border border-white/10 shrink-0" data-id="element-211">
                    {t.name.charAt(0)}
                  </div>
                  <div data-id="element-212">
                    <p className="font-bold text-white text-sm" data-id="element-213">{t.name}</p>
                    <p className="text-xs text-gray-500 mt-0.5" data-id="element-214">{t.info}</p>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* 6. FINAL URGENCY */}
      <section className="py-20 px-4 bg-gradient-to-b from-[#1565c0] to-[#0a1628] text-white text-center relative overflow-hidden" data-id="element-215">
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10" data-id="element-216"></div>

        <div className="relative z-10 max-w-3xl mx-auto" data-id="element-217">
          <h3 className="text-3xl md:text-5xl font-black mb-10 drop-shadow-md" data-id="element-218">
            Hacé clic y empezá hoy.
          </h3>
          <button onClick={() => scrollToSection('compra')} className="bg-white text-[#1565c0] hover:bg-gray-100 text-xl font-bold py-5 px-12 rounded-full shadow-2xl hover:shadow-white/20 transition-all flex items-center justify-center mx-auto gap-3 transform hover:-translate-y-1" data-id="element-219">
            ACCEDER AHORA <ArrowRight size={24} data-id="element-220" />
          </button>

          <footer className="mt-20 text-sm text-white/60 border-t border-white/20 pt-8" data-id="element-221">
            <p data-id="element-222">
              © {new Date().getFullYear()} Salud y Adolescencia 360. Todos los
              derechos reservados.
            </p>
            <p className="mt-2 text-xs" data-id="element-223">
              Este sitio no forma parte de Facebook o Facebook Inc.
            </p>
          </footer>
        </div>
      </section>
    </div>;
}